import React from "react"
import { Row } from 'react-bootstrap'
import NumericDisplay from './numericDisplay'

class EnrolmentTracker extends React.Component {
  constructor() {
    super()
  }

  render() {
      return (

          <NumericDisplay endpointFunction={"get_enrolment_count_ytd"}  />
       
      )
  } 
}

export default EnrolmentTracker

